import { render } from "./AppointmentForm.vue?vue&type=template&id=d66c2d9c&scoped=true&ts=true"
import script from "./AppointmentForm.ts?vue&type=script&lang=ts"
export * from "./AppointmentForm.ts?vue&type=script&lang=ts"

import "./AppointmentForm.scss?vue&type=style&index=0&id=d66c2d9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d66c2d9c"]])

export default __exports__